export class Tracking {
    _id_tracking: Number;    
    numero_cliente: String;
    numero_aviso: String;    
    token: String;
 }